import { Component, OnInit } from '@angular/core';
import { FooterService } from '../../components/footer/footer.service';
import { CommonService } from '../../shared/common.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { StorageKey, StorageService } from '../../shared/storage.service';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.css']
})
export class FaqsComponent implements OnInit {
  faqs: any[] = [];
  faqsData: any[] = [
    {
      title: 'About Our Services',
      faq: [
        {
          question: 'What services do you offer for religious travelers?',
          answer: 'We provide end-to-end solutions for religious tourism, including customized itineraries, transportation, accommodations near holy sites, multilingual guides, assistance with rituals, and recommendations for local vegetarian food. Our focus is on making your spiritual journey seamless and fulfilling.',
          isOpen: false
        },
        {
          question: 'Can you customize the itinerary for specific temples or religious events?',
          answer: 'Absolutely. Whether it’s visiting the sacred ghats of Varanasi, attending the evening Ganga Aarti, or exploring South Indian temple architecture, we customize your journey based on your spiritual interests, time, and preferences.',
          isOpen: false
        },
        {
          question: 'How do you ensure comfort for international travelers?',
          answer: 'We prioritize comfort by providing clean, air-conditioned transport, accommodation with modern amenities, and guides who are well-versed in local customs. We also handle permits, temple entry formalities, and language barriers to ensure a hassle-free experience.',
          isOpen: false
        }
      ]
    },
    {
      title: 'Major Religious Events in India',
      faq: [
        {
          question: 'What is the Kumbh Mela, and when does it happen?',
          answer: 'The Kumbh Mela is a massive spiritual gathering that rotates between Prayagraj, Haridwar, Nashik, and Ujjain every 12 years. Millions of devotees take a holy dip in sacred rivers to cleanse their souls. We organize guided visits, ensuring safe access to ceremonies and key bathing ghats.',
          isOpen: false
        },
        {
          question: 'What is Maha Shivaratri, and where can I celebrate it?',
          answer: 'Maha Shivaratri is the night of Lord Shiva\'s cosmic dance and a time for deep spiritual reflection. It is celebrated in temples across India, with special grandeur at Varanasi\'s Kashi Vishwanath Temple and Tamil Nadu\'s Chidambaram Temple. We arrange fast-track darshan and participation in the night-long prayers and rituals.',
          isOpen: false
        },
        {
          question: 'What makes Navratri special in India?',
          answer: 'Navratri, dedicated to Goddess Durga, is a nine-day festival marked by fasting, garba dances, and vibrant decorations. Gujarat hosts spectacular garba and dandiya events, while Kolkata is famous for its artistic Durga Puja pandals. We provide curated experiences for both spiritual and cultural aspects of this grand festival.',
          isOpen: false
        },
        {
          question: 'Can you explain the significance of the Ratha Yatra in Puri?',
          answer: 'The Ratha Yatra, or Chariot Festival, is an annual event in Puri, Odisha, where the deities of Lord Jagannath, Balabhadra, and Subhadra are taken out in massive chariots for devotees to pull. It’s an incredible sight of devotion and tradition. We ensure reserved spaces for a close view of the procession.',
          isOpen: false
        },
        {
          question: 'What happens during the Amarnath Yatra?',
          answer: 'The Amarnath Yatra is a pilgrimage to a high-altitude cave shrine in Kashmir, where a naturally formed ice Shiva Linga is worshipped. We provide comprehensive assistance, including permits, helicopter bookings, and acclimatization tips for a safe and sacred journey.',
          isOpen: false
        },
        {
          question: 'How do I experience the Guru Purab festival?',
          answer: 'Guru Purab, celebrating Sikh Gurus, is observed with hymns, processions, and langars (community meals) at Gurudwaras. The Golden Temple in Amritsar is a must-visit during this festival. We arrange guided visits to immerse you in the celebrations.',
          isOpen: false
        }
      ]
    },
    {
      title: 'Temple and Religious Spot Visits',
      faq: [
        {
          question: 'What are the must-visit temples in North India?',
          answer: 'North India boasts temples like Kashi Vishwanath in Varanasi, Kedarnath in Uttarakhand, and the Golden Temple in Amritsar. Each site offers a unique spiritual ambiance, and we provide detailed insights about their history and significance during your visit.',
          isOpen: false
        },
        {
          question: 'Can you help with rituals and offerings at temples?',
          answer: 'Yes, our guides are trained to assist with rituals such as Puja bookings, offerings, and special darshans (viewings) for a divine and stress-free experience. For example, at Tirupati Balaji Temple, we arrange fast-track entry to save time.',
          isOpen: false
        },
        {
          question: 'Are there any ancient Jain temples worth visiting?',
          answer: 'Absolutely! We recommend visiting the Dilwara Temples in Mount Abu, Ranakpur Jain Temple in Rajasthan, and Gomateshwara in Shravanabelagola. These architectural marvels reflect the essence of Jain spirituality and history.',
          isOpen: false
        }
      ]
    },
    {
      title: 'Cultural and Festival Experiences',
      faq: [
        {
          question: 'How can I experience Holi in its true essence?',
          answer: 'To celebrate Holi, we recommend destinations like Mathura and Vrindavan, the birthplace of Lord Krishna. Our tours include visits to famous temples, participation in Phoolon ki Holi (flower Holi), and vibrant street celebrations, all while ensuring safety and comfort.',
          isOpen: false
        },
        {
          question: 'What is special about Onam celebrations in Kerala?',
          answer: 'Onam showcases Kerala\'s rich culture with grand feasts, traditional dances like Kathakali, and thrilling boat races. We arrange stays at houseboats and visits to Onam events, ensuring you don’t miss this cultural extravaganza.',
          isOpen: false
        },
        {
          question: 'How do I attend Durga Puja in Kolkata?',
          answer: 'Our Durga Puja tours guide you to the best pandals (elaborate temporary temples), traditional rituals, and cultural performances. You’ll also get to enjoy authentic Bengali cuisine and witness the vibrant immersion process of the goddess idols.',
          isOpen: false
        }
      ]
    },
    {
      title: 'Practical Information',
      faq: [
        {
          question: 'How do you ensure a smooth journey for first-time visitors?',
          answer: 'We provide detailed pre-travel guidance, including tips on attire, etiquette, and temple protocols. Our team also handles all logistics, including visa assistance, to ensure first-time visitors feel at ease.',
          isOpen: false
        },
        {
          question: 'What kind of transportation do you offer?',
          answer: 'We provide a range of transportation options, including private cars, mini-buses, and luxury coaches, depending on group size. All vehicles are air-conditioned and driven by experienced professionals familiar with religious routes.',
          isOpen: false
        },
        {
          question: 'Can you arrange local vegetarian meals?',
          answer: 'Yes, we ensure that your meals align with dietary preferences, including sattvic (pure) food near temples. We also include options for local delicacies like Gujarati thalis, South Indian meals, and North Indian chaat.',
          isOpen: false
        }
      ]
    },
    {
      title: 'Pilgrimage for Specific Interests',
      faq: [
        {
          question: 'Are there special tours for Buddhist pilgrims?',
          answer: 'Yes, we offer Buddhist circuit tours covering key sites like Bodh Gaya (enlightenment), Sarnath (first sermon), Kushinagar (nirvana), and Lumbini in Nepal (birthplace). These are designed to provide a deep spiritual connection.',
          isOpen: false
        },
        {
          question: 'Do you offer yoga and meditation retreats?',
          answer: 'Definitely! We arrange yoga and meditation retreats in Rishikesh, Haridwar, and Kerala. These include sessions with experienced gurus, visits to ashrams, and serene stays by rivers or beaches for holistic rejuvenation.',
          isOpen: false
        },
        {
          question: 'Can I visit Sikh pilgrimage sites?',
          answer: 'Of course! Our tours include visits to key Gurudwaras like the Golden Temple, Hemkund Sahib, and Anandpur Sahib, offering insights into Sikhism\'s rich traditions and history.',
          isOpen: false
        }
      ]
    },
    {
      title: 'Safety and Comfort',
      faq: [
        {
          question: 'How do you ensure safety during the tours?',
          answer: 'We prioritize safety by choosing trusted accommodations, ensuring hygienic food, and providing local emergency support. Our guides are trained to assist in any situation, ensuring peace of mind throughout your journey.',
          isOpen: false
        },
        {
          question: 'What kind of travel insurance do you recommend?',
          answer: 'We advise all travelers to opt for comprehensive travel insurance covering medical emergencies, cancellations, and delays. If needed, we can recommend providers with the best coverage for India.',
          isOpen: false
        }
      ]
    },
    {
      title: 'Special Offers and Discounts',
      faq: [
        {
          question: 'Are there any group discounts available?',
          answer: 'Yes, we offer attractive discounts for groups, especially for families or spiritual organizations. Custom packages can also include complimentary cultural experiences for larger groups.',
          isOpen: false
        },
        {
          question: 'Do you have any early bird offers for festival tours?',
          answer: 'Early bookings for major events like the Kumbh Mela or Holi often come with discounted rates and priority access to prime locations during ceremonies.',
          isOpen: false
        }
      ]
    }
  ];

  errorMessage: string = '';

  constructor(
    private router: Router,
    private footerService: FooterService,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    public storageService: StorageService, private meta: Meta, private title: Title
  ) { }

  ngOnInit(): void {
    this.metaTagAdd()  //////  Meta tags add for SEO  //////
    this.footerService.hideFooter();
    // this.fetchFaqs();
  }

  metaTagAdd() {
    this.title.setTitle('FAQs | My Yatra 360 — Frequently Asked Questions');

    this.meta.updateTag({
      name: 'description',
      content: 'Have questions? Find answers to common doubts about My Yatra 360’s travel services, AI trip planner, booking, cancellations & more.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'FAQs'
    });
  }
  fetchFaqs(): void {
    // const userId = this.storageService.getValue(StorageKey._id);

    // if (userId) {
    //   const faqsData = { userId: userId };

    this.userLayoutService.faqs().subscribe((response: any) => {
      if (response.code === 1) {
        this.faqs = response.data.map(faq => ({ ...faq, isOpen: false }));
        // console.log("faqs", this.faqs);
      } else {
        this.errorMessage = response.message;
        this.commonService.notifier.notify('error', response.message);
      }
    },
      (error) => {
        this.errorMessage = 'Failed to fetch profile data';
        // console.log('Profile API Error:', error);
        this.commonService.notifier.notify('error', this.errorMessage);
      });
    // } else {
    //   this.errorMessage = 'No user ID found. Please log in.';
    //   this.commonService.notifier.notify('error', this.errorMessage);
    // }
  }

  goBack(): void {
    this.router.navigate(['home']);
  }

  toggleContent(faqIndex: number, index: number): void {
    // this.faqs[index].isOpen = !this.faqs[index].isOpen;
    this.faqsData[faqIndex].faq[index].isOpen = !this.faqsData[faqIndex].faq[index].isOpen
  }
}
